/*
 * @Author: zwh2 zwh2@meitu.com
 * @Date: 2025-06-12 10:04:39
 * @LastEditors: zwh2 zwh2@meitu.com
 * @LastEditTime: 2025-06-12 10:21:04
 * @FilePath: /roboneo-web/src/hooks/useDisableWheelZoom.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useEventListener } from 'ahooks';

/**
 * 禁用浏览器的放缩
 *
 * @export
 */
export default function useDisableWheelZoom() {
  /**
   * 拦截浏览器级缩放滚轮（Windows/Linux 常见为 ctrl，macOS 可能为 meta）。
   */
  const handleWheel = (event: WheelEvent) => {
    if (event.ctrlKey || event.metaKey) {
      event.preventDefault();
    }
  };

  /**
   * 拦截 macOS 触控板手势缩放，避免误触导致页面 DOM 被系统放大。
   */
  const handleGesture = (event: Event) => {
    event.preventDefault();
  };

  // 在捕获阶段提前拦截，避免默认缩放先触发。
  const listenerOptions = {
    passive: false,
    capture: true,
  };

  useEventListener('wheel', handleWheel, {
    target: () => window,
    ...listenerOptions,
  });

  useEventListener('wheel', handleWheel, {
    target: () => document,
    ...listenerOptions,
  });

  useEventListener('gesturestart', handleGesture, {
    target: () => window,
    ...listenerOptions,
  });

  useEventListener('gesturechange', handleGesture, {
    target: () => window,
    ...listenerOptions,
  });

  useEventListener('gestureend', handleGesture, {
    target: () => window,
    ...listenerOptions,
  });

  useEventListener('gesturestart', handleGesture, {
    target: () => document,
    ...listenerOptions,
  });

  useEventListener('gesturechange', handleGesture, {
    target: () => document,
    ...listenerOptions,
  });

  useEventListener('gestureend', handleGesture, {
    target: () => document,
    ...listenerOptions,
  });
}
